import htmx from "htmx.org";
import type SearchResult from "./SearchResult.ts";
import type { IDownloadCompleted, SelectionRange } from "../global";
import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { bindHtmxUpdate } from "../handlers/updates.ts";

export default class SearchUpload extends AlpineComponent {
  constructor(
    public url: string,
    public query: string,
    public index: number,
    public selection: SelectionRange | null
  ) {
    super();
  }

  init() {
    bindHtmxUpdate(this.$el)
  }

  getUrl() {
    var qs = new URLSearchParams()
    qs.set("query", this.query)
    qs.set("index", this.index.toString())
    return `${this.url}?${qs.toString()}`
  }

  onNewDocument(e: CustomEvent<IDownloadCompleted>) {
    const { files } = e.detail;
    const fileInput = this.$refs.fileInput as HTMLInputElement;
    fileInput.files = files;

    htmx.trigger(this.$el, "submit", {});
  }

  onRefresh() {
    const fileInput = this.$refs.fileInput as HTMLInputElement;
    fileInput.files = null;
    htmx.trigger(this.$el, "submit", {});
  }

  onSearchQuery(e: CustomEvent<string>) {
    this.query = e.detail;
  }

  onSearchResultSelected(e: CustomEvent<SearchResult>) {
    this.index = e.detail.index;
  }

  onSelectionChange(e: CustomEvent<SelectionRange>) {
    this.selection = e.detail
  }

  onSelectonStopObserving() {
    this.selection = null
  }
}
